import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute overflow-x-hidden -top-16 -right-14 text-accent-yellow" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  width: "120",
  height: "119",
  viewBox: "0 0 120 119",
  class: "",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    opacity: "1",
    d: "M6.38128 49.1539C3.20326 32.893 13.809 17.1346 30.0699 13.9566L70.3846 6.07751C86.6455 2.89948 102.404 13.5052 105.582 29.7661L113.461 70.0808C116.639 86.3417 106.033 102.1 89.7724 105.278L49.4577 113.157C33.1968 116.335 17.4384 105.729 14.2604 89.4686L6.38128 49.1539Z",
    fill: "currentColor"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_base_button, {
      class: "relative -top-14 -right-4",
      "custom-style": "round-white",
      "custom-icon": "bigInfo",
      "icon-shown": true,
      "on-click": _ctx.openDisclaimerModal
    }, null, 8, ["on-click"])
  ]))
}